<template>
    <div class="w-full h-screen bg-transparent-gray fixed top-0 left-0 z-50 justify-center items-center" :class="{'hidden': !isVisible, 'flex': isVisible}">
        <div class="w-[600px] h-fit bg-white rounded-xl">
            <div class="flex justify-between items-center">
                <slot name="name"></slot>
                <CrossCloseWindowSvg v-on:click="closeModal"/>
            </div>
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script setup>
import { defineModel } from 'vue';
import CrossCloseWindowSvg from './svg/CrossCloseWindowSvg.vue';

const isVisible = defineModel()

function closeModal() {
    isVisible.value = false
}

</script>

<style scoped>
    .bg-transparent-gray {
        background-color: rgba(100, 100, 100, 0.568);
    }
</style>